import { create } from 'zustand';

interface SidebarState {
  isOpen: boolean;        // Desktop sidebar open/collapsed state
  isMobileOpen: boolean;  // Mobile slide-over drawer open/closed state
  toggle: () => void;
  toggleDesktop: () => void;
  setDesktopOpen: (open: boolean) => void;
  toggleMobile: () => void;
  setMobileOpen: (open: boolean) => void;
  closeMobile: () => void;
}

export const useSidebarStore = create<SidebarState>((set, get) => ({
  isOpen: typeof window !== 'undefined' ? localStorage.getItem('forge:sidebar') !== 'closed' : true,
  isMobileOpen: false,

  toggle: () => {
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      set((s) => ({ isMobileOpen: !s.isMobileOpen }));
    } else {
      get().toggleDesktop();
    }
  },

  toggleDesktop: () => {
    set((s) => {
      const next = !s.isOpen;
      try {
        localStorage.setItem('forge:sidebar', next ? 'open' : 'closed');
      } catch {}
      return { isOpen: next };
    });
  },

  setDesktopOpen: (open: boolean) => {
    try {
      localStorage.setItem('forge:sidebar', open ? 'open' : 'closed');
    } catch {}
    set({ isOpen: open });
  },

  toggleMobile: () => set((s) => ({ isMobileOpen: !s.isMobileOpen })),
  setMobileOpen: (open: boolean) => set({ isMobileOpen: open }),
  closeMobile: () => set({ isMobileOpen: false }),
}));
